import React, { Component } from 'react';
import { Field } from 'redux-form';
import { api, apiUtils } from 'app/services';
import {
KBDateInput,
KBTextarea,
KBSelect,
KBFormError,
KBButton,
KBPopoverTop } from
'components';
import { LINE_ITEM_TYPES } from 'app/constants';
import { getSubScriptionsByOrg } from 'app/selectors';
import { toKBField } from 'components/formAdapters/reduxFormAdapters';

const renderLineInput = ({ input, meta, type }) => (
  <React.Fragment>
    <input type={type} {...input} />
    {meta.touched && meta.error &&
    <p className="lr-error">
      {' '}
      {meta.error}{' '}
    </p>}
  </React.Fragment>
);

const renderLineSelect = ({ input, meta, ...props }) => (
  <KBSelect field={toKBField(input, meta)} {...props} />
);

const renderLineTextarea = ({ input, meta, ...props }) => (
  <KBTextarea field={toKBField(input, meta)} {...props} />
);

var OrgOffHireForm = class extends React.Component {constructor(props) {super(props);this.state = this.getInitialState();this.deleteLineItem = this.deleteLineItem.bind(this);}getInitialState()
  {
    return {
      refund_type: [] };

  }componentDidMount()

  {
    api.getSubscriptionLineItemRefundType().then(
    json => {
      this.setState({ refund_type: json.response.body });
    },
    error => {});

  }deleteLineItem(

  line_items, index) {
    const lineItem = line_items.get(index) || {};
    KBPopoverTop.plugins.confirm(
    '删除账款',
    `确定要删除该账款单价：${lineItem.unit_price}, 数量：${lineItem.units}, 说明：${lineItem.description}?`,
    {
      confirm: () => {
        line_items.remove(index);
        KBPopoverTop.close();
      } });


  }render()

  {
    const { fields: line_items, taxes } = this.props;

    return (
      <div className="kb-form-container">
        <fieldset className="fieldset">
          <div className="form-content">
            {line_items.length ?
            <ul className="region-input-box">
                {line_items &&
              line_items.map((name, index) => {
                return (
                  <li key={index}>
                        <div className="kb-row">
                          <i
                      className="iconfont icon-close"
                      onClick={() =>
                      this.deleteLineItem(line_items, index)} />


                          <div className="kb-row">
                            <div className="kb-form-group kb-form-alone kb-div-210">
                              <label>金额</label>
                              <div>
                                <Field name={`${name}.unit_price`} type="text" component={renderLineInput} />
                              </div>
                            </div>
                          </div>
                          {/* <div className='kb-row'>
                           <div className='kb-form-group kb-form-alone kb-div-210'>
                             <label>数量</label>
                             <div>
                               <input type='number' { ...line.units } />
                               { line.units.touched && line.units.error && <p className='lr-error'> { line.units.error } </p> }
                             </div>
                           </div>
                        </div> */}
                          <div className="kb-row">
                            <Field
                        defaultValue="-1"
                        name={`${name}.line_item_type`}
                        component={renderLineSelect}
                        arrayData={LINE_ITEM_TYPES}
                        title="类型"
                        className="kb-form-group kb-form-c18 kb-form-alone" />

                          </div>
                          <div className="kb-row">
                            <Field
                        defaultValue="-1"
                        name={`${name}.sales_tax_id`}
                        component={renderLineSelect}
                        arrayData={taxes}
                        title="税率"
                        className="kb-form-group kb-form-210 kb-form-alone" />

                          </div>
                          <div className="kb-row">
                            <Field
                        className="kb-form-group kb-form-210 kb-form-alone"
                        title="退款类型"
                        name={`${name}.refund_type`}
                        component={renderLineSelect}
                        arrayData={this.state.refund_type} />

                          </div>
                          <div className="kb-row">
                            <Field
                        name={`${name}.description`}
                        component={renderLineTextarea}
                        title="说明"
                        className="kb-form-group kb-form-210 kb-form-alone" />

                          </div>
                        </div>
                      </li>);

              })}
              </ul> :

            ''}


            <div className="f-left">
              <button
              className="bordered-btn"
              style={{ marginLeft: 0 }}
              onClick={() => {
                line_items.push({ units: 1 });
              }}
              type="button">

                <i className="iconfont icon-add" />
                账款
              </button>
            </div>
          </div>
        </fieldset>
      </div>);

  }};


export default OrgOffHireForm;
